import React from 'react';
import { DEFAULT_CURRENCY_CODE } from '../../../constants/currency.const';
import { SUCCESS_LOGO_PATH } from '../../../constants/logo';
import { formatCurrency } from '../../../utils/fiat-currency.util';
import { getCurrentDateAndTime } from '../../../utils/getCurrentDateAndTime';
interface SuccessPopupParams {
  onClose: () => void;
  transactionLimit?: number;
  status?: string;
  type: string;
  currencyCode?: string;
}
const SuccessPopup: React.FC<SuccessPopupParams> = ({
  onClose,
  transactionLimit,
  status,
  type,
  currencyCode = DEFAULT_CURRENCY_CODE
}) => {
  return (
    <div>
      <img src={SUCCESS_LOGO_PATH} className="mx-auto h-32" alt="" />
      {type === 'resetPIN' ? (
        <h2 className="mb-3 mt-2 text-center text-sm font-bold md:text-lg">
          Your PIN has been updated successfully
        </h2>
      ) : status === 'turnedOn' ? (
        <>
          <h2 className="mb-5 mt-2 text-center text-sm font-bold md:text-lg">
            PIN is no longer required for transactions below the selected limit
          </h2>
          <div className="flex items-center justify-between">
            <span className="md:text-md text-sm">Status</span>
            <span className="md:text-md text-sm font-bold">Success</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="md:text-md text-sm">Date & Time</span>
            <span className="md:text-md text-sm font-bold">
              {getCurrentDateAndTime()}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="md:text-md text-sm">Transaction Limit</span>
            <span className="md:text-md text-sm font-bold">
              {formatCurrency(transactionLimit ?? 0, currencyCode)}
            </span>
          </div>
        </>
      ) : (
        <>
          <h2 className="mb-3 mt-2 text-center text-sm font-bold md:text-lg">
            PIN is now required for all transactions
          </h2>
          <div className="flex items-center justify-between">
            <span className="md:text-md text-sm">Status</span>
            <span className="md:text-md text-sm font-bold">Success</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="md:text-md text-sm">Date & Time</span>
            <span className="md:text-md text-sm font-bold">
              {getCurrentDateAndTime()}
            </span>
          </div>
        </>
      )}
      <button
        type="button"
        className="mx-auto mt-10 block w-full rounded-3xl border-1 border-green-800 bg-green-800 px-9 py-3 text-center font-bold capitalize text-white"
        style={{ opacity: true ? 1 : 0.5 }} // Adjust opacity condition as needed
        onClick={onClose}
      >
        Done
      </button>
    </div>
  );
};

export default SuccessPopup;
